<script setup>
import { computed } from 'vue'
import AiThinking from './AiThinking.vue'
import ChatChartLight from "./ChatChartLight.vue";

const props = defineProps({
  role: {
    type: String,
    required: true // 'ai' | 'user'
  },
  content: {
    type: String,
    default: ''
  },
  isStreaming: {
    type: Boolean,
    default: false
  },
  statusKey: {
    type: String,
    default: ''
  },
  msgType: {
    type: String,
    default: '0'
  },
  chartData: { type: [Array, Object, String], default: () => [] },
  field: { type: [Array, String], default: () => [] },
  title: {
    type: String,
    default: ''
  },
  subTitle: {
    type: String,
    default: ''
  }
})

const isAI = computed(() => props.role === 'ai')

/* 是否图表消息 */
const isChart = computed(() => String(props.msgType) !== '0')

</script>

<template>
  <div :class="['chat-row', isAI ? 'ai' : 'user']">

    <!-- AI头像 -->
    <div v-if="isAI" class="avatar ai-avatar">AI</div>

    <!-- 气泡 -->
    <div
        :class="[
        'bubble',
        isAI ? 'ai-bubble' : 'user-bubble',
        isStreaming ? 'streaming' : '',
        isChart ? 'chart-bubble' : ''
      ]"
    >

      <!-- streaming 状态 -->
      <AiThinking
          v-if="isStreaming"
          :statusKey="statusKey"
      />

      <!-- 正常内容 -->
      <template v-else>

        <!-- 文本 -->
        <div v-if="String(msgType) === '0'" class="text-content">
          {{ content }}
        </div>

        <!-- 图表 -->
        <div v-else class="chart-wrapper">
          <ChatChartLight
              :type="msgType"
              :chartData="chartData"
              :field="field"
              :title="title"
              :subTitle="subTitle"
          />
        </div>

      </template>
    </div>

    <!-- 用户头像 -->
    <div v-if="!isAI" class="avatar user-avatar">ME</div>

  </div>
</template>

<style scoped>

/* ===== 行布局 ===== */
.chat-row {
  display: flex;
  width: 100%;
  margin-bottom: 45px;
  gap: 20px;
}

.chat-row.ai {
  justify-content: flex-start;
}

.chat-row.user {
  justify-content: flex-end;
}

/* ===== 头像 ===== */
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

/* AI头像 */
.ai-avatar {
  background: linear-gradient(135deg, #0066FF, #00A3FF);
  color: #FFFFFF;
  box-shadow: 0 4px 10px rgba(0, 102, 255, 0.25);
}

/* 用户头像 */
.user-avatar {
  background: #E2E8F0;
  color: #64748B;
}

/* ===== 气泡基础 ===== */
.bubble {
  max-width: 70%;
  padding: 22px 30px;
  border-radius: 20px;
  font-size: 15px;
  line-height: 1.7;
  word-break: break-word;
  white-space: pre-wrap;
  transition: all 0.2s ease;
}

/* ===== 图表专用气泡 ===== */
.chart-bubble {
  width: 100%;
  max-width: 900px;   /* 控制图表最大宽度 */
  padding: 24px;
}

/* ===== AI 气泡 ===== */
.ai-bubble {
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  color: #334155;
  box-shadow: 0 6px 20px rgba(0, 0, 0, .04);
  border-top-left-radius: 4px;
}

/* ===== 用户气泡 ===== */
.user-bubble {
  background: #E1EFFF;
  border: 1px solid #BADAFF;
  color: #1E40AF;
  box-shadow: 0 4px 12px rgba(0, 102, 255, .08);
  border-top-right-radius: 4px;
}

/* ===== streaming 特效 ===== */
.streaming {
  width: fit-content;
  background: linear-gradient(180deg, #F8FBFF, #EEF5FF);
  border: 1px solid #D6E4FF;
}

/* 文本块 */
.text-content {
  width: 100%;
}

/* 图表外层 */
.chart-wrapper {
  width: 100%;
}

</style>
